/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_C_Li2Inputs */

const tr_mesafeli_s8_c_li2 = /** @type {(inputs: Mesafeli_S8_C_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt bilgilerinin doğru, güncel ve eksiksiz olmasını sağlamak.`)
};

const en_mesafeli_s8_c_li2 = /** @type {(inputs: Mesafeli_S8_C_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To ensure that the registration data is correct, up to date and complete.`)
};

const de_mesafeli_s8_c_li2 = /** @type {(inputs: Mesafeli_S8_C_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dafür sorgen, dass die Registrierungsdaten richtig, aktuell und vollständig sind.`)
};

const ru_mesafeli_s8_c_li2 = /** @type {(inputs: Mesafeli_S8_C_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обеспечивать достоверность, актуальность и полноту регистрационных данных.`)
};

/**
* | output |
* | --- |
* | "To ensure that the registration data is correct, up to date and complete." |
*
* @param {Mesafeli_S8_C_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_c_li2 = /** @type {((inputs?: Mesafeli_S8_C_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_C_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_c_li2(inputs)
	if (locale === "de") return de_mesafeli_s8_c_li2(inputs)
	if (locale === "ru") return ru_mesafeli_s8_c_li2(inputs)
	return tr_mesafeli_s8_c_li2(inputs)
});